import { useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import { font500Sx, tertiaryHoverSx } from '../../styles/Global.style';
import { Text } from '../Text/Text';
import { helperLinkSx, helperLinkTextSx } from './HelperLink.style';
import { Copy } from '../../copy/Copy';

export const HelperLink = ({ to, textIdentifier, linkText, onClick, sx }) => {
  const theme = useTheme();

  return (
    <>
      <Text
        text={Copy.inject(textIdentifier, {
          injectLink: (
            <Link to={to} style={helperLinkSx} onClick={onClick}>
              <Text
                component="span"
                text={linkText}
                sx={{
                  ...tertiaryHoverSx(theme),
                  ...helperLinkTextSx(theme),
                  ...sx,
                  color: theme.palette.tertiary.main,
                }}
              />
            </Link>
          ),
        })}
        sx={{ ...font500Sx, ...sx }}
      />
    </>
  );
};
